module.exports = __webpack_public_path__ + "img/GALERIA-CIAZ-2021-5.7f91e297.jpg";